/**
 * Copyright 2023 Design Barn Inc.
 */

import type { AudioOptionsV1 } from '../common';
import { LottieAudioCommonV1 } from '../common';

export class LottieAudioV1 extends LottieAudioCommonV1 {
  public constructor(options: AudioOptionsV1) {
    super(options);
  }
}
